(() => {
  const element = document.getElementById('rdr-analytics-config');
  if (!element || window.RdrAnalytics) return;
  let config;
  try { config = JSON.parse(element.textContent); } catch { return; }
  const key = 'rdr_analytics_session_v2';
  const timeout = 30 * 60 * 1000;
  const query = new URLSearchParams(window.location.search);
  const now = () => Date.now();
  const read = () => {
    for (const storage of ['localStorage', 'sessionStorage']) {
      try {
        const value = JSON.parse(window[storage].getItem(key) || 'null');
        if (value) return value;
      } catch {}
    }
    return null;
  };
  const save = (value) => {
    for (const storage of ['localStorage', 'sessionStorage']) {
      try {
        if (value) window[storage].setItem(key, JSON.stringify(value));
        else window[storage].removeItem(key);
        window[storage].removeItem('rdr_view_session');
        window[storage].removeItem('rdr_visit_source');
      } catch {}
    }
  };
  const host = (value) => {
    try { return new URL(value).hostname.toLowerCase(); } catch { return ''; }
  };
  const referrerHost = host(document.referrer);
  const internal = (value) => ['rdrsoftware.de', 'rdrsoftware.sk', host(window.location.href)].some(
    (domain) => value === domain || value.endsWith(`.${domain}`),
  );
  const external = referrerHost && !internal(referrerHost) ? referrerHost : '';
  const utm = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].reduce((values, name) => {
    values[name] = (query.get(name) || '').slice(0, 255);
    return values;
  }, {});
  const has = (name) => Boolean((query.get(name) || '').trim());
  const explicit = (utm.utm_source || query.get('source') || '').toLowerCase();
  const medium = utm.utm_medium.toLowerCase();
  const classify = () => {
    const hint = explicit || external;
    if (hint.includes('billiger')) return 'billiger';
    if (hint.includes('guenstiger') || hint.includes('günstiger')) return 'guenstiger';
    if (hint.includes('pepita')) return 'pepita';
    if ((!explicit || hint.includes('google')) && ['gclid', 'gbraid', 'wbraid'].some(has)) return 'google_ads';
    if (!explicit && has('soluteclid') && query.get('soluteclid') !== '1') return 'billiger';
    if (!explicit && has('emid')) return 'guenstiger';
    if (hint.includes('google')) {
      if (/product_sync|shopping|merchant|feed/.test(medium)) return 'google_shopping';
      return /cpc|ppc|paid|ads/.test(medium) ? 'google_ads' : 'google_organic';
    }
    if (/chatgpt|openai/.test(hint)) return 'chatgpt';
    if (/instagram/.test(hint) || hint === 'ig') return 'instagram';
    if (/facebook|meta/.test(hint) || hint === 'fb' || (!explicit && has('fbclid'))) return 'facebook';
    if (/email|mail/.test(hint)) return 'email';
    if (explicit || external) return 'other';
    return 'direct';
  };
  const entrySource = classify();
  const entrySignal = Boolean(explicit || external || ['gclid', 'gbraid', 'wbraid', 'fbclid', 'soluteclid', 'emid'].some(has));
  const signature = JSON.stringify([entrySource, ...Object.values(utm)]);
  let session = null;
  let permission = { analytics: false, marketing: false, ready: false };
  let sync = null;
  let synchronized = '';
  let started = false;
  let privacyRetryTimer = null;
  let privacyRetryDeadline = now() + 30000;
  let privacyRetryCount = 0;
  let privacyLoadCount = 0;
  let privacyLoadUntil = 0;
  const sources = new Set(['billiger', 'guenstiger', 'pepita', 'google_ads', 'google_shopping', 'google_organic', 'facebook', 'instagram', 'chatgpt', 'email', 'direct', 'other', 'unknown']);
  let activitySavedAt = 0;
  const pixels = new Set();
  const status = () => !permission.ready ? 'unavailable' : (permission.analytics && permission.marketing ? 'allowed' : 'declined');
  const allowed = () => permission.analytics && permission.marketing;
  const ensureSession = () => {
    if (!permission.analytics) return null;
    if (!session) session = read();
    const campaignChanged = entrySignal && session && session.signature !== signature;
    if (!session || !/^[a-zA-Z0-9_-]{16,120}$/.test(session.sid || '') || !sources.has(session.source) || !Number.isFinite(session.last)
      || now() - session.last >= timeout || session.last > now() + 60000 || campaignChanged) {
      session = {
        sid: window.crypto?.randomUUID?.() || `${now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`,
        source: permission.marketing ? entrySource : 'unknown',
        signature,
        last: now(),
        landing_path: permission.marketing ? window.location.pathname.slice(0, 500) : '',
        referrer_host: permission.marketing ? external : '',
        ...Object.fromEntries(Object.entries(utm).map(([name, value]) => [name, permission.marketing ? value : ''])),
      };
    }
    session.last = now();
    save(session);
    return session;
  };
  const snapshot = () => {
    if (!allowed()) return '';
    const current = ensureSession();
    return JSON.stringify({ v: 2, consent: true, sid: current.sid, source: current.source, at: now() });
  };
  const setHidden = (form, name, value) => {
    let input = [...form.querySelectorAll('input[type="hidden"]')].find((field) => field.name === name);
    if (!value) { input?.remove(); return; }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.append(input);
    }
    input.value = value;
  };
  const prepareForm = (form) => {
    let action;
    try { action = new URL(form.action, window.location.href); } catch { return; }
    if (action.origin !== window.location.origin) return;
    if (/\/cart\/add(?:\.js)?\/?$/.test(action.pathname)) {
      setHidden(form, 'properties[_rdr_analytics_v2]', snapshot());
    } else if (/\/cart\/?$/.test(action.pathname)) {
      setHidden(form, 'attributes[rdr_analytics_v2]', snapshot());
      setHidden(form, 'attributes[rdr_measurement_status]', status());
    }
  };
  const prepareForms = () => document.querySelectorAll('form[action]').forEach(prepareForm);
  const send = (event, extra = {}) => {
    if (!permission.analytics) return;
    const current = ensureSession();
    const params = new URLSearchParams({
      event, sid: current.sid, source: permission.marketing ? current.source : 'unknown', tracking_version: '2',
      path: window.location.pathname,
      ...extra,
    });
    if (permission.marketing) {
      for (const name of Object.keys(utm)) params.set(name, current[name] || '');
      if (current.landing_path) params.set('landing', current.landing_path);
      if (current.referrer_host) params.set('ref', `https://${current.referrer_host}/`);
    }
    const pixel = new Image(1, 1);
    pixels.add(pixel);
    pixel.onload = pixel.onerror = () => pixels.delete(pixel);
    pixel.referrerPolicy = 'no-referrer';
    pixel.src = `https://admin.rdrsoftware.de/track/product-view.gif?${params}`;
  };
  const syncCart = () => {
    const value = snapshot();
    const body = { attributes: { rdr_analytics_v2: value, rdr_measurement_status: status() } };
    const identity = value ? `${session.sid}|${session.source}` : status();
    if (identity === synchronized) return Promise.resolve(true);
    if (sync) return sync.then(() => syncCart());
    const abort = new AbortController();
    const timer = setTimeout(() => abort.abort(), 3500);
    sync = fetch(`${(config.root || '/').replace(/\/?$/, '/')}cart/update.js`, {
      method: 'POST', credentials: 'same-origin', keepalive: true,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body), signal: abort.signal,
    }).then((response) => {
      if (!response.ok) return false;
      synchronized = identity;
      return true;
    }).catch(() => false).finally(() => { clearTimeout(timer); sync = null; });
    return sync;
  };
  const checkoutProducts = (control) => {
    try { return JSON.parse(control?.dataset.rdrCheckoutProducts || '[]'); } catch { return []; }
  };
  const sendCheckout = (control) => [...new Set(checkoutProducts(control))].forEach((product) => send('checkout', { product }));
  const begin = () => {
    if (!permission.analytics || started) return;
    started = true;
    ensureSession();
    send('session_start');
    send('page_view');
    if (config.product) send('', { product: config.product });
    if (config.collection) send('collection_view', { collection: config.collection, collection_title: config.collectionTitle || '' });
  };
  const refreshConsent = (synchronize = true) => {
    const privacy = window.Shopify?.customerPrivacy;
    const previous = { ...permission };
    try {
      permission = {
        ready: Boolean(privacy),
        analytics: privacy?.analyticsProcessingAllowed() === true,
        marketing: privacy?.marketingAllowed() === true,
      };
    } catch { permission = { ready: false, analytics: false, marketing: false }; }
    if (previous.ready && (permission.analytics !== previous.analytics || permission.marketing !== previous.marketing)) {
      session = null;
      save(null);
      started = false;
      synchronized = '';
    }
    if (!allowed()) { session = null; save(null); synchronized = ''; }
    if (!permission.analytics) started = false;
    begin();
    prepareForms();
    if (synchronize && config.cartCount > 0) syncCart();
    return permission.ready;
  };
  // Shopify's loader can arrive after this deferred asset, fail, or never call
  // back. Retry reads for a bounded interval; never infer or grant consent.
  const schedulePrivacyRetry = () => {
    if (permission.ready || privacyRetryTimer !== null || now() >= privacyRetryDeadline) return;
    const delay = Math.min(250 * (2 ** Math.min(privacyRetryCount++, 3)), 2000, privacyRetryDeadline - now());
    privacyRetryTimer = setTimeout(() => {
      privacyRetryTimer = null;
      recoverConsent();
    }, delay);
  };
  const recoverConsent = (interaction = false, synchronize = true) => {
    if (refreshConsent(synchronize)) {
      if (privacyRetryTimer !== null) clearTimeout(privacyRetryTimer);
      privacyRetryTimer = null;
      return;
    }
    if (interaction && now() >= privacyRetryDeadline) {
      privacyRetryDeadline = now() + 5000;
      privacyRetryCount = 0;
      privacyLoadCount = 0;
    }
    const loader = window.Shopify?.loadFeatures;
    if (typeof loader === 'function' && privacyLoadCount < 3
      && now() < privacyRetryDeadline && now() >= privacyLoadUntil) {
      const attempt = ++privacyLoadCount;
      privacyLoadUntil = now() + 5000;
      try {
        loader.call(window.Shopify, [{ name: 'consent-tracking-api', version: '0.2' }], () => {
          if (attempt === privacyLoadCount) privacyLoadUntil = 0;
          refreshConsent();
          schedulePrivacyRetry();
        });
      } catch { privacyLoadUntil = 0; }
    }
    schedulePrivacyRetry();
  };
  document.addEventListener('visitorConsentCollected', () => recoverConsent(true));
  window.addEventListener('pageshow', () => recoverConsent(true));
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') recoverConsent(true);
  });
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    recoverConsent(true);
    prepareForm(form);
    if (event.submitter?.name === 'checkout') sendCheckout(event.submitter);
    if (form.matches('form[action*="/cart/add"]') && form.closest('#rdr21-purchase')) {
      const selected = form.querySelector('[data-family-product-url][aria-current="true"], [data-product-handle][aria-current="true"], [data-corel-product-url][aria-current="true"]');
      let handle = selected?.dataset.familyHandle || selected?.dataset.productHandle || '';
      try { handle ||= new URL(selected?.href).pathname.match(/\/products\/([^/?#]+)/)?.[1] || ''; } catch {}
      if (handle || config.product) send('cart', { product: handle || config.product });
    }
  }, true);
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const checkout = event.target.closest('a[data-rdr-checkout-products]');
    if (checkout) {
      const target = new URL(checkout.href, window.location.href);
      if (target.origin === window.location.origin && /\/checkout\/?$/.test(target.pathname)) {
        recoverConsent(true);
        sendCheckout(checkout);
        if (!event.defaultPrevented && event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
          event.preventDefault();
          Promise.race([syncCart(), new Promise((resolve) => setTimeout(resolve, 1500))])
            .finally(() => window.location.assign(target.href));
        }
      }
    }
    const product = event.target.closest('a[href*="/products/"]');
    const handle = product?.getAttribute('href')?.match(/\/products\/([^/?#]+)/)?.[1];
    if (handle && config.collection) send('collection_product_click', { product: handle, collection: config.collection, collection_title: config.collectionTitle || '' });
  }, true);
  document.addEventListener('pointerdown', () => {
    recoverConsent(true);
    if (permission.analytics && now() - activitySavedAt > 30000) {
      activitySavedAt = now();
      ensureSession();
      prepareForms();
    }
  }, { passive: true });
  new MutationObserver((changes) => {
    if (changes.some((change) => [...change.addedNodes].some((node) => node.nodeType === 1 && (node.matches?.('form') || node.querySelector?.('form'))))) prepareForms();
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.RdrAnalytics = {
    prepareForms: () => { recoverConsent(true); prepareForms(); },
    syncCart: () => { recoverConsent(true, false); return syncCart(); },
  };
  prepareForms();
  recoverConsent();
})();
